import styled from "styled-components";
import { LoginWrapper } from "../Login/styles";

export const SimpleButton = styled.button`
  background-color: transparent;
  border: 0;
  color: #fff;
  font-size: 14px;
  margin-top: 15px;
  display: flex;
  ::before {
    display: none;
  }
`;

export { LoginWrapper };
